import { ToestelClass } from '@/domain/interface/activiteit/kenmerk/ToestelClass';

export class ToestelRequestDto {
  meldingId?: string;
  fabricatienummer?: string;
  fabricatienummerOnbekend?: boolean;
  nominaalVermogen?: number;
  brandstof?: string;
  branderTechnologie?: string;
  merk?: string;
  merkOnbekend?: boolean;
  toestelType?: string;
  toestelTypeOnbekend?: boolean;
  ketelType?: string;
  bouwjaar?: number;
  bouwjaarOnbekend?: boolean;

  constructor(toestel: ToestelClass, meldingId?: string) {
    this.meldingId = meldingId;
    this.fabricatienummer = toestel.fabricatienummer;
    this.fabricatienummerOnbekend = toestel.fabricatienummerOnbekend;
    this.nominaalVermogen = toestel.nominaalVermogen;
    this.brandstof = toestel.brandstof?.omschrijving;
    this.branderTechnologie = toestel.branderTechnologie?.omschrijving;
    this.merk = toestel.merk;
    this.merkOnbekend = toestel.merkOnbekend;
    this.toestelType = toestel.toestelType;
    this.toestelTypeOnbekend = toestel.toestelTypeOnbekend;
    this.ketelType = toestel.ketelType?.omschrijving;
    this.bouwjaar = toestel.bouwjaar;
    this.bouwjaarOnbekend = toestel.bouwjaarOnbekend;
  }
}
